// extracted by mini-css-extract-plugin
export var boxItems = "_7y-1";
export var button = "_7y-5";
export var filterGroupBox = "_7y-0";
export var icon = "_7y-2";
export var iconSecondary = "_7y-4";
export var iconWrapper = "_7y-3";